import { useRouter } from 'next/router';
import { memo } from 'react';
import styles from './FilterMenu.module.scss';
import Box from '@/components/UI/box/Box';
import DatePicker from './datePicker/DatePicker';
import GuestCount from './guestCount/GuestCount';
import PriceRange from './priceRange/PriceRange';
import Installment from '@/components/search/filters/filtersMenu/installment/Installment';
const defaultFilters = [{
  component: <DatePicker />
}, {
  component: <GuestCount />
}, {
  component: <PriceRange />
}];
const snappFilterItem = {
  component: <Installment />
};
const FiltersMenu = () => {
  const router = useRouter();
  const filters = [...defaultFilters];
  if (router?.query?.installment_payment) {
    filters.splice(1, 0, snappFilterItem);
  }
  return <Box className={styles['filters-menu-container']} data-sentry-element="Box" data-sentry-component="FiltersMenu" data-sentry-source-file="FiltersMenu.tsx">
      <Box className={styles['filter-container']} data-sentry-element="Box" data-sentry-source-file="FiltersMenu.tsx">
        <Box component="ul" className={styles['filter-items-container']} data-sentry-element="Box" data-sentry-source-file="FiltersMenu.tsx">
          {filters.map((item, index) => <li key={index} className={styles['filter-item']}>
              {item.component}
            </li>)}
        </Box>
      </Box>
    </Box>;
};
export default memo(FiltersMenu);